export function normalizePath(pathname: string) {
  const path = pathname.replace(/\/+$/, "");
  return path === "" ? "/" : path;
}

export function stripGoPrefix(path: string) {
  if (path === "/go") {
    return "/";
  }

  if (path.startsWith("/go/")) {
    return path.replace(/^\/go/, "");
  }

  return path;
}

export function isLocalHost(host: string) {
  return host === "localhost" || host === "127.0.0.1";
}

export function isGoHost(host: string) {
  return host === "go.thh.com.br" || host.endsWith(".go.thh.com.br");
}

export function isMainHost(host: string) {
  return (
    isLocalHost(host) ||
    host === "staging.thh.com.br" ||
    host === "thh.com.br" ||
    host === "www.thh.com.br"
  );
}

